<template>
  <div class="uk-container uk-container-expand">
    <div class="uk-grid uk-child-width-1-1" data-uk-grid>
      <div>
        <div class="uk-flex uk-flex-between uk-flex-middle">
          <div>
            <h3 class="uk-h3">
              <span data-uk-icon="icon: cog;ratio: 1.5"></span> Einstellungen
            </h3>
          </div>
          <div></div>
        </div>
      </div>
    </div>
    <div class="uk-grid" data-uk-grid>
      <div class="uk-width-1-1">
        <ul data-uk-tab>
          <li>
            <a href="#">Allgemein</a>
          </li>
        </ul>
        <ul class="uk-switcher uk-margin">
          <li>
            <general />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import "izitoast/dist/css/iziToast.min.css";
import iziToast from "izitoast/dist/js/iziToast.min.js";
import General from "@/components/settings/General";
export default {
  data() {
    return {
      checked: [],
      allSelected: false
    };
  },
  components: {
    General
  },
  mounted() {
    //
  },
  computed: {
    //
  },
  methods: {
    //
  }
};
</script>
